import { ContextWorkbenchVersionGroupKey, OrgGuideFilePath } from "@hex/common";

import { WorkbenchHistory } from "../../workbench/state/history.types";

import { ContextWorkbenchHistoryTimelineSelectableNodeData } from "./contextWorkbenchHistoryTimelineNode";

export namespace ContextWorkbenchHistory {
  export const TimelineSortDirection = WorkbenchHistory.TimelineSortDirection;
  export type TimelineSortDirection = WorkbenchHistory.TimelineSortDirection;

  export const VersionPanelTabId = WorkbenchHistory.VersionPanelTabId;
  export type VersionPanelTabId = WorkbenchHistory.VersionPanelTabId;

  export const VersionPanelChangesFilter =
    WorkbenchHistory.VersionPanelChangesFilter;
  export type VersionPanelChangesFilter =
    WorkbenchHistory.VersionPanelChangesFilter;

  export type ExpandedState = WorkbenchHistory.ExpandedState<
    ContextWorkbenchVersionGroupKey,
    OrgGuideFilePath
  >;

  export type State = WorkbenchHistory.State<
    ContextWorkbenchHistoryTimelineSelectableNodeData["id"],
    ContextWorkbenchVersionGroupKey,
    OrgGuideFilePath
  >;
}
